var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_660_3499",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_660_3499",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADpklEQVR4nO3c3atmcxjG8e81tteQJnIgpDRSEk3OKErKif+AAxpsTGPGqKnJ2IW8RKk5MpgajZoiL8mJiDNOlCNHcuKl2DQoSozLwaytnezZt9nPb93rWev+HN97rat99fz2evZavwWllFJKKaWUUkoppZwkx3xt+7zsrKvZXooEn/V5N836gEEXAU8nnXtQsgoA2Gb7lsTzD0JmAQIO2D4nMUO6zAIALgWeSs6QKrsAgEXbN2eHyDKEAlaWorOzg2QYQgEAlwGPZ4fIMJQCALbbviE7RN+GVMAm4CXbZ2YH6dOQCgDYAjyWHaJPQysAYKft67ND9GWIBawsRWdkB+nDEAsAuAJ4NDtEH4ZaAMBu29dlh2htyAUsAIfGvhRlFfBxcO5KYG/LINmyCngPOBSc3WN7a8swmTKXoB3AN4G5BeCg7dMa50mRVoCkn4HF4PjVwJ6GcdKk/hGW9A7wWnD8EdvXtsyTYQhXQfcB3wfmVpaiUxvn6VV6AZJ+AHYFx68BHm4Yp3fpBQBIehV4Kzi+z/ZVLfP0aRAFdO4HjgbmTgdetn1K4zy90HoDLR5GmhJJJ/wdD+kTMElVQLIqIFkVkKwKSFYFjE1wf8BS8FgLtj8NHnPZ9gUbyD2p/QEhkv4E7gL+CIyfDzzbNtHsDboAAEmfAc8Fx++wfVvLPLM2+AI6S8Dnwdn9nqM9B3NRgKTfOb4UHQuMXwI82TbR7MxFAQCSPgH2B8cX5+VB37kpoLMX+CIwNzcP+s5VAZJ+A7YBkcvBLcC+tok2bq4KAJD0EXAgOL576I+01P2Axup+wMBVAcmqgGRVQLIqIFkVMDazvB/wP897k+2/gud/8D9+vu4HbISkD4l/QXvC9uUt80SNpoDOQ8CXgbmzgBdtr/tFtLVRFSDpV+BuYv8rurGbTTWqAgAkfQAcDI4/Y/vilnnWM7oCOruArwJz5wIvNM5yQqMsQNIvwJ3ElqJbbd/eONKaRlkAgKT3gVeC488DFzaMs6bRFtDZCXwbmNvM8XvOvRt1AZKOEr/SSdl7NuoCACS9CxzOzrGW0RfQ2U5sU3jvJlGApJ+Ibwrv1SQKgH82hR/JzvFvkymg8wDwXXaI1SZVgKQfgXuyc6w2qQIAJL0NvJ6dY8XkCugsEns/RXOTLKB7P8WO7Bww0QIAJB0B3sjOMdkCOvcCy5kBJl2ApGXir8ppYtIFAEg6DLyZdf7JF9CJviqnlFJKKaWUUkoppZST9jdmU/dvB0T7bgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.ffcb8b4c1846508542fdb462dc84c20f.svg";
export { ForwardRef as ReactComponent };